<template>
    <div class="stripe-subscription-form">
        <div>
            <div>
                <div v-for="item in step.fields" :key="item.id" class="form-row">
                    <span class="form-row-title" :style="$parent.config.fieldTitleStyles">
                        {{ item.title }}
                        <span
                            v-if="config[item.id] && config[item.id].info"
                            style="padding: 0 10px"
                            @click="$parent.showInfo(config[item.id].info)"
                        >
                            <i class="fa fa-info-circle" style="font-size: 20px" />
                        </span>
                    </span>
                    <v-text-field
                        v-if="item.type == 'input' && (!config[item.id] || (config[item.id] && config[item.id].type !== 'numeric'))"
                        v-model="item.value"
                        :disabled="item.disabled ? true : false"
                        :maxlength="config[item.id] && config[item.id].maxlength ? config[item.id].maxlength : null"
                        return-masked-value
                        :mask="config[item.id] && config[item.id].mask ? config[item.id].mask : null"
                        hide-details
                        outline
                        rounded
                        clearable
                        :class="$parent.config.inputStyles"
                    />
                    <v-text-field
                        v-if="item.type == 'input' && config[item.id] && config[item.id].type === 'numeric'"
                        v-model="item.value"
                        :disabled="item.disabled ? true : false"
                        :maxlength="config[item.id] && config[item.id].maxlength ? config[item.id].maxlength : null"
                        return-masked-value
                        :mask="config[item.id] && config[item.id].mask ? config[item.id].mask : null"
                        hide-details
                        outline
                        rounded
                        clearable
                        oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                        :class="$parent.config.inputStyles"
                    />
                    <v-select
                        v-if="item.type == 'select'"
                        v-model="item.value"
                        item-text="label"
                        item-value="value"
                        :items="item.items"
                        no-data-text="Sem dados"
                        hide-details
                        outline
                        :class="$parent.config.inputStyles"
                        append-icon="fa-caret-down"
                    />
                </div>
            </div>
        </div>
        <div v-if="terms" class="row stripe-terms-checkbox" style="margin-top: 0">
            <div class="checkbox-container">
                <div
                    @click="termsValue = !termsValue"
                    class="checkbox-container-box"
                    :style="{ 'border-color': $parent.config.textColor, color: $parent.config.textColor }"
                >
                    <div v-if="termsValue">
                        <i class="fa fa-check"></i>
                    </div>
                </div>
                <div @click="termsValue = !termsValue">
                    {{ $parent.str['terms_and_conditions'] }}
                </div>
            </div>
            <a @click.stop="openTerms()" class="nav-link">
                {{ $parent.str['read_terms_and_conditions'] }}
            </a>
        </div>
        <div v-if="gdpr" class="row stripe-terms-checkbox" style="margin-top: 0">
            <div class="checkbox-container">
                <div
                    @click="gdprValue = !gdprValue"
                    class="checkbox-container-box"
                    :style="{ 'border-color': $parent.config.textColor, color: $parent.config.textColor }"
                >
                    <div v-if="gdprValue">
                        <i class="fa fa-check"></i>
                    </div>
                </div>
                <div @click="gdprValue = !gdprValue">
                    {{ $parent.str[step.gdprLabel] ? $parent.str[step.gdprLabel] : step.gdprLabel }}
                </div>
            </div>
            <a @click.stop="openGdpr()" class="nav-link">
                {{ $parent.str[step.gdprLabelOpen] ? $parent.str[step.gdprLabelOpen] : step.gdprLabelOpen }}
            </a>
        </div>
    </div>
</template>
<style scoped>
.stripe-subscription-form input {
    color: #000;
}
</style>
<script>
import Utils from '../services/Utils'

export default {
    name: 'stripe-subscription',
    props: ['step', 'terms', 'gdpr'],
    data() {
        return {
            termsValue: false,
            gdprValue: false,
            config: {
                card_number: {
                    type: 'numeric',
                    mask: '#### #### #### ####',
                    info: null,
                    maxlength: null,
                },
                card_month: {
                    type: 'numeric',
                    mask: null,
                    info: null,
                    maxlength: 2,
                },
                card_year: {
                    type: 'numeric',
                    mask: null,
                    info: null,
                    maxlength: 4,
                },
                card_cvc: {
                    type: 'numeric',
                    mask: null,
                    info: this.$parent.str['cvc_information'],
                    maxlength: 4,
                },
            },
        }
    },
    methods: {
        openTerms: function () {
            if (window.appReceiveLink) {
                document.getElementById('link-view').setAttribute('data', this.terms)
                document.getElementById('link-view').click()
            } else {
                window.open(this.terms, '_blank').focus()
            }
        },
        openGdpr: function () {
            if (window.appReceiveLink) {
                document.getElementById('link-view').setAttribute('data', this.gdpr)
                document.getElementById('link-view').click()
            } else {
                window.open(this.gdpr, '_blank').focus()
            }
        },
        validated: function () {
            if (this.terms && !this.termsValue) {
                this.$alert(this.step.termsFailedMessage, '', 'warning', Utils.getAlertOptions())
                return false
            }
            if (this.gdpr && !this.gdprValue) {
                this.$alert(
                    this.$parent.str[this.step.gdprFailedMessage]
                        ? this.$parent.str[this.step.gdprFailedMessage]
                        : this.step.gdprFailedMessage,
                    '',
                    'warning',
                    Utils.getAlertOptions(),
                )
                return false
            }
            if (!this.$parent.validateFields()) {
                return false
            }
            return true
        },
    },
}
</script>
